import React from 'react';
const BreadCrums = ({name, code, description, descriptionValue, returnType, returnTypeValue}) => {
  return (
    <>
      <div className="new-standard-textfields breadcrum-block">
        <div className="d-flex breadcrum-textfields">
          <p>
            <b>{name} :</b>
          </p>
          <p>&nbsp;{code?.replace(/ /g, '\u00a0')} </p>
        </div>
        {description ? (
          <div className="d-flex   breadcrum-textfields">
            <p>
              <b>{description} :</b>
            </p>
            <p>&nbsp;{descriptionValue?.replace(/ /g, '\u00a0')}</p>
          </div>
        ) : null}

        {returnType ? (
          <div className="d-flex  breadcrum-textfields">
            <p>
              <b>{returnType} :</b>
            </p>
            <p>&nbsp;{returnTypeValue}</p>
          </div>
        ) : null}
      </div>
    </>
  );
};
export default BreadCrums;
